export default {
	root: {
		letterSpacing: '0.75px',
	},
};
